(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["savoy-product-stories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('savoy-product-stories')) {
    customElements.define('savoy-product-stories', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-story-open]');
          if (opener && !opener.disabled) {
            const dialog = document.getElementById(opener.dataset.storyOpen);
            if (!dialog || !this.contains(dialog) || dialog.open) return;
            this.opener = opener;
            const player = dialog.querySelector('.sv-stories__player');
            if (!player.firstElementChild) player.append(dialog.querySelector('template').content.cloneNode(true));
            dialog.showModal();
            const video = player.querySelector('video');
            video.currentTime = 0;
            video.play()?.catch(() => {});
          }
          if (event.target.closest('[data-story-close]')) event.target.closest('dialog').close();
        }, options);
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, options);
          dialog.addEventListener('close', () => {
            dialog.querySelector('video')?.pause();
            dialog.querySelector('.sv-stories__player').replaceChildren();
            this.opener?.focus({ preventScroll: true });
          }, options);
        });
      }
      disconnectedCallback() {
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["savoy-wrist-sizing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('savoy-wrist-sizing')) {
  customElements.define('savoy-wrist-sizing', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('[data-wrist-input]');
      const status = this.querySelector('[data-wrist-status]');
      const clear = this.querySelector('[data-wrist-clear]');
      const update = () => {
        input.setCustomValidity('');
        const invalid = !input.validity.valid;
        input.setCustomValidity(invalid ? this.dataset.error : '');
        input.setAttribute('aria-invalid', String(invalid));
        clear.hidden = input.value === '' && !invalid;
        this.dispatchEvent(new CustomEvent('savoy:wrist-change', { bubbles: true }));
        status.textContent = invalid ? this.dataset.error : input.value === '' ? '' : this.dataset.confirmation.replace('{size}', new Intl.NumberFormat(this.dataset.locale, {maximumFractionDigits: 1}).format(input.valueAsNumber));
      };
      input.addEventListener('input', update);
      input.addEventListener('change', update);
      input.addEventListener('invalid', () => {
        update();
      });
      clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
      const form = input.form;
      const dialog = this.querySelector('[data-wrist-dialog]');
      let submitter;
      this.confirmSizing = event => {
        if (input.value !== '' || !input.validity.valid) return true;
        event.preventDefault();
        event.stopImmediatePropagation();
        submitter = event.submitter;
        if (!dialog.open) dialog.showModal();
        return false;
      };
      this.querySelector('[data-wrist-dismiss]').addEventListener('click', () => dialog.close());
      this.querySelector('[data-wrist-measure]').addEventListener('click', () => {
        dialog.close();
        input.focus();
      });
      this.querySelector('[data-wrist-default]').addEventListener('click', () => {
        input.value = '18.5';
        update();
        dialog.close();
        const addButton = submitter || form.querySelector('[type="submit"]');
        addButton?.focus();
        form.requestSubmit(addButton || undefined);
      });
      input.form?.addEventListener('reset', () => setTimeout(update, 0));
      update();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
